import { api } from 'app/config/apiConfig';
import { USERS_PATH } from '../utils/constants';
import { Reservation } from 'entities/Reservation';

interface Params {
  userId: string | undefined;
  active?: boolean;
  isTakenUp?: boolean;
}

export const getUserReservationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserReservations: builder.query<Reservation[], Params>({
      query: (params) => ({
        url: `${USERS_PATH}/${params.userId}/reservations`,
        params,
      }),
      providesTags: (result) => ['Reservations'],
    }),
  }),
});

export const { useGetUserReservationsQuery } = getUserReservationsApi;
